import {useEffect, useRef} from 'react'
import {useIntl} from 'react-intl'
import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {ShippingCalculators} from './components/ShippingCalculators'

export function ShippingCalculatorsPage() {
  const intl = useIntl()
  const previousTitleRef = useRef<string>(document.title)

  useEffect(() => {
    document.title = intl.formatMessage({id: 'SHIPPING_CALCULATORS_PAGE_TITLE'})
    const previousTitle = previousTitleRef.current
    return () => {
      document.title = previousTitle
    }
  }, [intl])

  return (
    <PublicWrapper>
      <div className='shipping-calculators-page-container'>
        <ShippingCalculators />
      </div>
    </PublicWrapper>
  )
}
